import { observabilityAppService } from '@ctct/myaccount-utils-static';

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
    utag: {
      link: (...args: unknown[]) => void;
    };
  }
}

class WindowObject {
  public gtag(...args: unknown[]) {
    window.gtag(...args);
  }

  public initGA4(accountId: string) {
    window.dataLayer = window.dataLayer || [];

    // we use it for fe secure app only, in the app.ctct we use distUI.track
    window.gtag = function gtag() {
      // eslint-disable-next-line prefer-rest-params
      window.dataLayer.push(arguments);
    };

    window.gtag('js', new Date());
    window.gtag('config', 'G-14T5LGLSQ3', { send_page_view: false });

    window.gtag('event', 'page_view', {
      page_location: window.location.pathname,
      page_title: document.title,
      SOID_hit: accountId,
      SOID_user: accountId,
    });
  }

  /**
   * Tealium Event Tracking
   * @param eventType event type
   * @param eventLabel label of event
   * @param eventMetadata metadata of event
   */
  public trackTealium = (eventType: string, eventLabel: string, eventMetadata: string): Promise<void> => {
    // combined, gives up to 10s retry time
    const maxRetries = 20;
    const retryDelay = 500;
    let attemptCount = 0;

    return new Promise<void>((resolve, reject) => {
      const tryTrack = () => {
        // window.utag might not be available immediately
        if (window?.utag) {
          window.utag.link({
            tealium_event: eventType,
            ga_event_category: eventType,
            ga_event_label: eventLabel,
            ga_event_action: eventMetadata,
          });
          resolve();
        } else if (attemptCount < maxRetries) {
          attemptCount += 1;
          setTimeout(tryTrack, retryDelay);
        } else {
          const error = new Error('Tealium is not available');

          observabilityAppService.notify(error, {
            message: 'Tealium is not available',
            eventType,
            eventLabel,
            eventMetadata,
          });
          reject(error);
        }
      };

      tryTrack();
    });
  };
}

export const windowObject = new WindowObject();
